export default __webpack_public_path__ + "static/media/logo-harmon-black.c6e61b0b.svg";